import Preact from 'preact';

var FormStructure = {
  fields: {
    headerLabel: {
      validations: []
    },
    clientname: {
      validations: []
    },
    firstName: {
      validations: [
        { type: 'required', message: 'Please provide a first name' }
      ]
    },
    lastName: {
      validations: [
        { type: 'required', message: 'Please provide a last name' }
      ]
    },
    email: {
      validations: [
        { type: 'required', message: 'Please provide an email' },
        { type: 'regex', pattern: '[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?', message: 'Please provide a valid email' }
      ]
    },
    telNumber: {
      validations: [
        { type: 'required', message: 'Please provide a phone number' }, ,
        { type: 'regex', pattern: '[(]{0,1}[0-9]{3}[) ]{0,2}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}', message: 'Please provide a valid phone number' }
      ]
    },
    plannedguestcount: {
      validations: [
        { type: 'regex', pattern: '^[0-9]*$', message: 'Please provide a guest count in numbers only.'},
      ]
    },
    eventDate: {
      validations: [
        { type: 'required', message: 'Please select a date for your event' },
        { type: 'dateinfuture', message: 'Event date must be in the future' }
      ]
    },
    starttime: {
      validations: []
    },
    category: {
      validations: []
    },
    notes: {
      validations: []
    }
  },
  layout: {
    rows: [
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Client Name:',
            mapping: 'clientname'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'First Name:*',
            mapping: 'firstName'
          },
          {
            type: 'text',
            size: 'Medium',
            label: 'Last Name:*',
            mapping: 'lastName'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Phone Number:*',
            mapping: 'telNumber'
      },
      {
            type: 'text',
            size: 'Medium',
            label: 'Email:*',
            mapping: 'email'
          }
        ]
      },
      {
        fields: [
          {
            type: 'date-picker',
            size: 'Medium',
            label: 'Event Date:*',
            mapping: 'eventDate'
          },
          {
            type: 'text',
            size: 'Medium',
            label: 'Planned Guest Count (minimum of 15):',
            mapping: 'plannedguestcount'
          }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'Time Needed:',
            options: [
              { label: '6:00 AM'  , value: '06:00:00'},
              { label: '6:30 AM'  , value: '06:30:00'},
              { label: '7:00 AM'  , value: '07:00:00'},
              { label: '7:30 AM'  , value: '07:30:00'},
              { label: '8:00 AM'  , value: '08:00:00'},
              { label: '8:30 AM'  , value: '08:30:00'},
              { label: '9:00 AM'  , value: '09:00:00'},
              { label: '9:30 AM'  , value: '09:30:00'},
              { label: '10:00 AM' , value: '10:00:00'},
              { label: '10:30 AM' , value: '10:30:00'},
              { label: '11:00 AM' , value: '11:00:00'},
              { label: '11:30 AM' , value: '11:30:00'},
              { label: '12:00 PM' , value: '12:00:00'},
              { label: '12:30 PM' , value: '12:30:00'},
              { label: '1:00 PM'  , value: '13:00:00'},
              { label: '1:30 PM'  , value: '13:30:00'},
              { label: '2:00 PM'  , value: '14:00:00'},
              { label: '2:30 PM'  , value: '14:30:00'},
              { label: '3:00 PM'  , value: '15:00:00'},
              { label: '3:30 PM'  , value: '15:30:00'},
              { label: '4:00 PM'  , value: '16:00:00'},
              { label: '4:30 PM'  , value: '16:30:00'},
              { label: '5:00 PM'  , value: '17:00:00'},
              { label: '5:30 PM'  , value: '17:30:00'},
              { label: '6:00 PM'  , value: '18:00:00'},
              { label: '6:30 PM'  , value: '18:30:00'},
              { label: '7:00 PM'  , value: '19:00:00'},
              { label: '7:30 PM'  , value: '19:30:00'},
              { label: '8:00 PM'  , value: '20:00:00'},
              { label: '8:30 PM'  , value: '20:30:00'},
              { label: '9:00 PM'  , value: '21:00:00'},
              { label: '9:30 PM'  , value: '21:30:00'},
              { label: '10:00 PM' , value: '22:00:00'},
              { label: '10:30 PM' , value: '22:30:00'},
              { label: '11:00 PM', value: '23:00:00' },
              { label: '11:30 PM', value: '23:30:00' },
              { label: '12:00 AM', value: '00:00:00' },
              { label: '12:30 AM', value: '00:30:00' },
              { label: '1:00 AM', value: '01:00:00' },
              { label: '1:30 AM', value: '01:30:00' },
              { label: '2:00 AM', value: '02:00:00' },
            ],
            mapping: 'starttime'
          }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'Market Location:',
            options: [
              { label: '001-Lemmon', value: '001-Lemmon'},
              { label: '002-Bethesda', value: '002-Bethesda'},
              { label: '004-Fort Worth', value: '004-Fort Worth'},
              { label: '005-Ballston', value: '005-Ballston'},
              { label: '006-Reston', value: '006-Reston'},
              { label: '008-Keller Springs', value: '008-Keller Springs'},
              { label: '010-Gaithersburg', value: '010-Gaithersburg'},
              { label: '011-Oakbrook', value: '011-Oakbrook'},
              { label: '012-Fairfax', value: '012-Fairfax'},
              { label: '014-Grapevine', value: '014-Grapevine'},
              { label: '015-Allen', value: '015-Allen'},
              { label: '018-Woodbridge', value: '018-Woodbridge'},
              { label: '020-Orland Park', value: '020-Orland Park'},
              { label: '022-Old Orchard', value: '022-Old Orchard'},
              { label: '023-Loudoun', value: '023-Loudoun'},
              { label: '024-Gainesville', value: '024-Gainesville'},
              { label: '025-Naperville', value: '025-Naperville'},
              { label: '027-Vernon Hills', value: '027-Vernon Hills'},
              { label: '028-Schaumberg', value: '028-Schaumberg'},
              { label: '029-Alliance', value: '029-Alliance'},
              { label: '030-Brentwood', value: '030-Brentwood'},
              { label: '031-Orlando', value: '031-Orlando'},
              { label: '033-Arlington', value: '033-Arlington'},
              { label: '034-Spring', value: '034-Spring'},
              { label: '035-Columbia', value: '035-Columbia'},
              { label: '036-Oklahome City', value: '036-Oklahome City'},
              { label: '037-Annapolis', value: '037-Annapolis'},
              { label: '038-Durham', value: '038-Durham'},
              { label: '039-Brookfield', value: '039-Brookfield'},
              { label: '041-HC Lonetree Englewood', value: '041-HC Lonetree Englewood'},
              { label: '042-HC Westminster', value: '042-HC Westminster'},
              { label: '044-HC Colorado Springs', value: '044-HC Colorado Springs'},
              { label: '046-HC Wheatridge', value: '046-HC Wheatridge'},
              { label: '049-Frontenac', value: '049-Frontenac'},
              { label: '050-Lubbock', value: '050-Lubbock'},
              { label: '051-Bridgewater', value: '051-Bridgewater'},
              { label: '052-Frisco', value: '052-Frisco'},
              { label: '053-Naples', value: '053-Naples'},
              { label: '054-Tulsa', value: '054-Tulsa'},
            ],
            mapping: 'category'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text-area',
            size: 'XLarge',
            label: 'Is there any additional information you would like to add?',
            mapping: 'notes'
          }
        ]
      },
      {
        fields: [
          {
            type: 'submit',
            size: 'XLarge',
            label: 'SEND'
          }
        ]
      }
    ]
  },
  info: {
    title: 'Uncle Julio\'s Contact Us Form',
    formId: '1916',
    clientKey: 'E47F0A0A-5427-4442-BBA2-55E6E2612F65',
    appKey: '23697F14-AA8C-4622-9F64-FC1A9FF20D0D',
    redirectUrl: '',
    submissionText: 'Thank you! Your web inquiry has been successfully sent. We will contact you within one business day.',
    apiEndpoint: '//api-cec.catereasewebtools.com/inbound-inquiries'
  }
};


export default FormStructure;
